/* @flow */
import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { translate } from 'react-i18next';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Modal, Card, CardHeader, CardContent, Divider, Button } from '@material-ui/core';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import { ElectroTooltip } from 'components/ExtendedUiElements/customized';
import { ModalSearch } from './ModalSearch';
import navigation from 'services/NavigationService';
import WelcomePageStore from 'stores/WelcomePageStore';
import styles from '../WelcomePage.module.scss';

import type { TranslatorProps } from 'react-i18next';

type ModalOptions = {
  url: string,
  to?: string,
};

type ModalLinkProps = {
  type: string,
  text: string,
  options: ModalOptions,
  isOpen?: () => boolean,
  tooltip?: string,
};

type InjectedProps = {
  welcomePageStore: WelcomePageStore,
} & TranslatorProps &
  RouteComponentProps;

@translate()
@inject('welcomePageStore')
@withRouter
@observer
export class ModalLink extends ComponentWithInjectedProps<ModalLinkProps, {}, InjectedProps> {
  @observable
  localState = {
    modal: {
      open: false,
    },
  };

  componentDidMount() {
    const { isOpen } = this.props;

    this.localState.modal.open = isOpen ? isOpen() : false;
  }

  componentWillUnmount() {
    const { welcomePageStore } = this.props;
    welcomePageStore.searchResults = [];
  }

  openModal() {
    const { options } = this.props;

    if (options.to) {
      this.props.history.push(options.to);
    } else {
      this.localState.modal.open = true;
    }
  }

  closeModal() {
    const { welcomePageStore } = this.props;
    this.localState.modal.open = false;
    welcomePageStore.searchResults = [];
    this.props.history.push('/welcome-page');
    welcomePageStore.selectedItemIndex = 0;
  }

  render() {
    const { options, text, type, t, welcomePageStore, tooltip } = this.props;
    const disabled = welcomePageStore.loading || welcomePageStore.searchResults.length === 0;
    const { selectedItem } = welcomePageStore;

    return (
      <React.Fragment>
        <div>
          {tooltip ? (
            <ElectroTooltip title={tooltip}>
              <a onClick={() => this.openModal()}>{text}</a>
            </ElectroTooltip>
          ) : (
            <a onClick={() => this.openModal()}>{text}</a>
          )}
        </div>
        <Modal onClose={this.closeModal.bind(this)} open={this.localState.modal.open}>
          <div className={styles.modalLinkCard}>
            <Card>
              <CardHeader title={text} />
              <Divider />
              <CardContent className={styles.modalLinkContent}>
                <ModalSearch {...options} type={type} />
                <div className={styles.modalButton}>
                  <Button color="secondary" variant="contained" onClick={() => this.closeModal()}>
                    {t('general:actions.close')}
                  </Button>
                  <Button
                    disabled={disabled}
                    color="primary"
                    variant="contained"
                    onClick={() => navigation.navigateTo(`/${options.url}/${selectedItem.id}`)}
                  >
                    {t('general:actions.view')}
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}
